import katex from 'katex'

/**
 * 서버 응답으로 인해 KaTeX 구조가 손상된 data-latex 요소를 복원한다.
 * 서버가 HTML 저장 시 .katex, .katex-mathml, .katex-html 등의 래퍼를
 * 벗겨내고 <math>...</math>x+y=z 형태로 반환하는 문제를 해결한다.
 */
export function restoreLatexElements(container: HTMLElement) {
	container.querySelectorAll('[data-latex]').forEach(el => {
		const htmlEl = el as HTMLElement

		if (htmlEl.contentEditable !== 'false') {
			htmlEl.contentEditable = 'false'
		}
		if (htmlEl.style.userSelect !== 'all') {
			htmlEl.style.userSelect = 'all'
		}

		if (el.querySelector('.katex')) return

		const formula = el.getAttribute('data-formula')
			|| el.querySelector('annotation[encoding="application/x-tex"]')?.textContent

		if (!formula) return

		try {
			htmlEl.innerHTML = katex.renderToString(formula, { throwOnError: false })
		} catch {
			// re-rendering 실패 시 현재 상태 유지
		}
	})
}
